@if (enabled) {
<aside class="w-12 uppercase c1"
       [ngClass]="customClass"
       [style.color]="style.textColor!"
       [style.background-color]="style.bgColor!"
       [htmlBinding]="label"></aside>
}